import { Component, OnInit } from '@angular/core';
import { UserInvoiceService } from '../_services/user-invoice.service';
import { Observable, combineLatest } from 'rxjs';
import { NetforumInvoice } from 'lms-api';
import { LmsUserService } from 'lms-api';
import { SlideInOutAnimation } from '../../animations';
import { UserCourseDataService } from 'lms-api';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
  animations: [SlideInOutAnimation]
})
export class MyAccountComponent implements OnInit {
  public Invoices$: Observable<NetforumInvoice[]>;
  public CEInvoices: boolean = false;
  active: boolean;
  activeInvoice: number;

  constructor(public invoiceService: UserInvoiceService, public lmsUserService: LmsUserService, public ucdService: UserCourseDataService) {
    this.Invoices$ = combineLatest(this.invoiceService.Invoices$, this.ucdService.Courses$, this.ucdService.Bundles$).pipe(
      map(([invoices, courses, bundles]) => {
        invoices.forEach(inv => {
          inv.InvoiceDetails.forEach(ivd => {
            if (ivd.ptp_code == 'Course Fee') {
              this.CEInvoices = true;
              let prcCode = ivd.prc_code;
              while(!ivd.CEItem && prcCode.length > 0) {
                if(courses.find(course => course.netforum_course_id == prcCode)) {
                  ivd.CEItem = courses.find(course => course.netforum_course_id == prcCode);
                }
                prcCode = prcCode.substring(1);
              }
            }
            if (ivd.ptp_code == 'Subscription') {
              this.CEInvoices = true;
              ivd.CEItem = bundles.find(bundle => bundle.product_code == ivd.prc_code);
            }
          })
        });
        return invoices;
      })
    );
  }
  toggleShowDiv(id: number) {
    this.activeInvoice = id

  }

  ngOnInit(): void {
  }

  public RefreshInvoices() {
    this.invoiceService.Refresh(true);
  }

}
